const indexShouldBeCollapsed = (index, currentPage, totalPages) => {
  if (index === 1 || index === currentPage || index === totalPages) {
    return false;
  }
  if (index < currentPage - 2 || index > currentPage + 2) {
    return true;
  }
  return false;
}

const ellipsesIsNotLastItem = (pageItems) => {
  return !pageItems[pageItems.length -1].isEllipses;
}

exports.paginate = (options) => {
  const resultCount = options.count;
  const pageSize = options.pageSize;
  const currentPage = options.activePage;
  const includePrevNext = options.includePrevNext;
  const totalPages = Math.floor(resultCount / pageSize) + (resultCount % pageSize > 0 ? 1 : 0);
  const pageItems = [];
  if (totalPages > 1) {
    if (currentPage > 1 && includePrevNext) {
      pageItems.push({
        pageNumber: currentPage - 1,
        linkText: '<<',
        titleText: 'navigate to previous page',
        selectedClass: 'active',
      });
    }
    for (let i = 1; i <= totalPages; i++) {
      if (indexShouldBeCollapsed(i, currentPage, totalPages)) {
        if (ellipsesIsNotLastItem(pageItems)) {
          pageItems.push({
            isEllipses: true,
            linkText: '...',
          });
        }
      } else {
        pageItems.push({
          pageNumber: i,
          linkText: i.toString(),
          titleText: 'navigate to page ' + i,
          selectedClass: (i === currentPage ? 'active' : ''),
          isCurrentPage: i === currentPage
        });
      }
    }
    if (currentPage < totalPages && includePrevNext) {
      pageItems.push({
        pageNumber: currentPage + 1,
        linkText: '>>',
        titleText: 'navigate to next page',
        selectedClass: 'active',
      });
    }
  }
  return pageItems;
};



// WEBPACK FOOTER //
// ./src/components/search/paginate.js